/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    Row,
    Modal,
    Button,
    message,
} from 'antd';
import {
    hashHistory,
    withRouter,
    Link,
} from 'react-router';
import {
    DmsTab,
    TableView,
    AdvanceFormNew,
} from 'Components';
import {
    commodityList,
    deleteCommodity,
} from '../../service/merchandise';
import {customerList} from '../../service/shoppingCar';
import {sKeylist} from '../../service/dictionary/dataitem';
import {getProductCategory} from '../../service/product';
import {
    showSpin,
    hideSpin,
} from 'Utils';
import {
    Store,
    Actions,
} from './store';

const confirm = Modal.confirm;

class InfoList extends Reflux.Component {
    constructor(props) {
        super(props);
        const currentChannel = window.sessionStorage.getItem('cur_channel') || '';
        this.channelCode = currentChannel.split('|')[1] || '';
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            groupOptions: [], // 商品分组
            seriesOptions: [], // 商品系列
            productCategoryTree: [], // 商品分类
            filterBoxVisible: false,
            customerList: [],
            selectedRowKeys: [],
            rows: [],
            total: 0,
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            searchObj: {
                channelCode: this.channelCode,
                customerName: '', //客户名称
                timeStart: '', //开始时间
                timeEnd: '', //结束时间
                name: '', //商品名称
                categoryShow: [], //商品分类
                proBigType: '', //商品大类
                proMiddleType: '', //商品中类
                proDetailType: '', //商品小类
                seriesCode: '', //商品序列：编码
                groupCode: '', //商品分组：编码
                showPriceStart: undefined, //牌价
                showPriceEnd: undefined, //牌价
                inventoryStart: undefined, //库存
                inventoryEnd: undefined, //库存
                s: 10,
                p: 1,
            },
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname;
        if (/^\/merchandise\/add\/\d+$/.test(path)) { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange({...this.state.searchObj});
            window.sessionStorage.removeItem('mechandise-form-data-cache')
        } else {
            Actions.useStoreChange(false);
        }
    }

    componentWillMount() { //准备数据
        const self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                },
            });
        }

        customerList(self.channelCode).then(res => { //人员
            if (res.status && res.code == 200) {
                const list = (res.data || []).map(x => ({value: `${x.id}`, text: x.name}));
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({
                            customerList: list,
                            searchObj: {
                                ...self.state.searchObj,
                                customerId: list[0] ? list[0].value : ''
                            },
                        });
                    }
                }, 200);
            } else {
                message.error(res.message);
            }
        });
    }

    componentDidMount() {
        this.mounted = true;
        sKeylist({sKey: 'commodity_group'}).then(res => {
            if (res.status) {
                this.setState({
                    groupOptions: (res.data || []).map(x => ({value: x.sKey, text: x.name})),
                });
            }
        });
        sKeylist({sKey: 'commodity_series'}).then(res => {
            if (res.status) {
                this.setState({
                    seriesOptions: (res.data || []).map(x => ({value: x.sKey, text: x.name})),
                });
            }
        });
        getProductCategory().then(res => {
            if (res.status) {
                const filterEmpty = (list, codePath) => list.map(x => {
                    let key = x.code; // 实际使用的业务数据是 code；
                    if (x.children && x.children.length) {
                        return {
                            ...x,
                            key: key, // 使用实际业务数据重新给 key 赋值
                            value: key, // 使用实际业务数据重新给 value 赋值
                            isLeaf: false,
                            disableCheckbox: !x.categoryId,
                            codePath: [...codePath, x.code],
                            children: filterEmpty(x.children, [...codePath, x.code]),
                        };
                    }
                    return {
                        ...x,
                        key: key, // 使用实际业务数据重新给 key 赋值
                        value: key, // 使用实际业务数据重新给 value 赋值
                        isLeaf: true,
                        disableCheckbox: !x.categoryId,
                        codePath: [...codePath, x.code],
                        children: undefined,
                    };
                });
                const tree = filterEmpty(res.data || [], []);
                const productCategoryTree = tree.filter(x => !/配件/ig.test(x.label));
                this.setState({
                    productCategoryTree,
                });
            }
        });
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    getData() {
        const self = this;
        const {searchObj} = this.state;
        commodityList(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data});
            } else {
                console.error(res.message);
            }
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        const self = this;
        this.setState({
                filterBoxVisible: false,
                searchObj: {
                    ...this.state.searchObj,
                    customerName: '', //客户名称
                    timeStart: '', //开始时间
                    timeEnd: '', //结束时间
                    name: '', //商品名称
                    categoryShow: [], //商品分类
                    proBigType: '', //商品大类
                    proMiddleType: '', //商品中类
                    proDetailType: '', //商品小类
                    seriesCode: '', //商品序列：编码
                    groupCode: '', //商品分组：编码
                    showPriceStart: undefined, //牌价
                    showPriceEnd: undefined, //牌价
                    inventoryStart: undefined, //库存
                    inventoryEnd: undefined, //库存
                    p: 1,
                },
            },
            function () {
                self.getData();
            });
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({filterBoxVisible: false, searchObj: {...this.state.searchObj, p: 1}}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        // console.log(name + ':\t' + value);
        if (name === 'time') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    timeStart: value.from,
                    timeEnd: value.end,
                },
            });
        } else if (name === 'showPrice') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    showPriceStart: value.from,
                    showPriceEnd: value.end,
                },
            });
        } else if (name === 'inventory') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    inventoryStart: value.from,
                    inventoryEnd: value.end,
                },
            });
        } else if (name === 'categoryShow') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    categoryShow: value,
                    proBigType: value && value[0] ? value[0] : '', // 商品大类
                    proMiddleType: value && value[1] ? value[1] : '', // 商品中类
                    proDetailType: value && value[2] ? value[2] : '', // 商品小类
                },
            });
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.getData();
        });
    }

    deleteHandle() {
        const self = this;
        const {selectedRowKeys} = this.state;
        if (!selectedRowKeys.length) {
            message.warn('请选择要删除的商品');
            return;
        }
        confirm({
            title: '确定要删除这些商品?',
            // content: 'When clicked the OK button, this dialog will be closed after 1 second',
            onOk() {
                showSpin();
                deleteCommodity({ids: selectedRowKeys, status: 1}).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && self.getData();
                });
            },
            onCancel() {
            },
        });
    }

    render() {
        const {
            rows, total, searchObj, customerList, selectedRowKeys,
            productCategoryTree, groupOptions, seriesOptions
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'customerId',
                    label: '客户名称',
                    text: '选择客户',
                    options: customerList,
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.customerId,
                },
                {
                    name: 'time',
                    label: '价格起始日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.timeStart || '',
                        end: searchObj.timeEnd || ''
                    },
                },
                {
                    name: 'name',
                    label: '商品名称',
                    text: '输入商品名称',
                    type: 'default',
                    defaultValue: searchObj.name
                },
                {
                    name: 'categoryShow',
                    label: '产品分类',
                    text: '产品分类',
                    options: productCategoryTree,
                    type: 'cascader',
                    defaultValue: searchObj.categoryShow,
                },
                {
                    name: 'seriesCode',
                    label: '商品系列',
                    text: '选择商品系列',
                    options: seriesOptions,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.seriesCode
                },
                {
                    name: 'groupCode',
                    label: '商品分组',
                    text: '选择商品分组',
                    options: groupOptions,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.groupCode
                },
                {
                    name: 'showPrice',
                    label: '牌价',
                    type: 'numComp',
                    defaultValue: {
                        from: searchObj.showPriceStart || '',
                        end: searchObj.showPriceEnd || '',
                    },
                },
                {
                    name: 'inventory',
                    label: '总库存',
                    type: 'numComp',
                    defaultValue: {
                        from: searchObj.inventoryStart || '',
                        end: searchObj.inventoryEnd || '',
                    },
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam,
        };
        const tableViewProps = {
            loading: false,
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange,
            },
            rowSelection: {
                selectedRowKeys: selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => this.setState({selectedRowKeys}),
            },
            columns: [
                {
                    title: '商品编码',
                    dataIndex: 'code',
                },
                {
                    title: '商品名称',
                    dataIndex: 'name',
                    // render: (text, record, index) => <a>{text}</a>,
                },
                {
                    title: '商品分类',
                    dataIndex: 'bigName',
                    render: (text, record, index) => {
                        return record.bigName + '.' + record.middleName + '.' + record.smallName;
                    },
                },
                {
                    title: '商品系列',
                    dataIndex: 'seriesName',
                },
                {
                    title: '商品分组',
                    dataIndex: 'groupName',
                },
                {
                    title: '牌价',
                    dataIndex: 'listPrice',
                },
                {
                    title: 'SKU数量',
                    dataIndex: 'skuNum',
                },
                {
                    title: '总库存',
                    dataIndex: 'storageInventory',
                },
                {
                    title: '创建时间',
                    dataIndex: 'createdDate',
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    render: (text, rrcord, index) => <a
                        onClick={() => this.goView(`/merchandise/add/${text}`)}>编辑</a>,
                },
            ],
            rows,
        };
        return <div className="dms-body">
            <DmsTab options={['商品管理']} defaultKey={0}>
                {/*<Button icon="plus" onClick={this.goView.bind(this, `/carousel/add/0`)}>新增</Button>*/}
            </DmsTab>

            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <Row className="mb-12" type="flex" justify="end" align="middle">
                    {this.state.userData.roleCode != 'cpxxwh' &&
                        <Button onClick={this.goView.bind(this, `/merchandise/add/0`)}>新建</Button>}
                    &emsp;
                    {this.state.userData.roleCode != 'cpxxwh' &&
                        <Button onClick={this.deleteHandle.bind(this)}>删除</Button>}
                    {/*&emsp;
           <Button onClick={this.invalidHandle.bind(this)}>一键禁用</Button>
           &emsp;
           <Button onClick={this.validHandle.bind(this)}>一键启用</Button>*/}
                </Row>
                <TableView {...tableViewProps} />
            </div>
        </div>;
    }
}

export default withRouter(InfoList);



// WEBPACK FOOTER //
// ./src/routes/merchandise/list.js